import { memo } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';

import { Button } from 'Components/Shared/UI';

import safeTranslate from 'utils/safeTranslate';

import useStyles from './styles';

const GoldAd = ({ deviceType }) => {
  const t = useTranslations();
  const router = useRouter();
  const styles = useStyles({ deviceType });

  return (
    <Container>
      <Row>
        <Col
          xs={12}
          sm={12}
          lg={{ offset: 1, size: 10 }}
          xl={{ offset: 1, size: 10 }}
        >
          <div className={styles['gold-ad--block']}>
            <div className={styles['info--block']}>
              <h3 className="title-content">
                <img src="/images/icons/gold_icon.svg" alt="" />
                {t('promotion_page_block_1_title')}
              </h3>
              <p className="sub-title-content">
                {t('promotion_page_block_1_subtitle')}
              </p>
              {deviceType !== 'desktop' && (
                <div className={styles['img--block']}>
                  <img src="/images/promotion/Gold_Ad.png" alt="Gold_Ad" />
                </div>
              )}
              <div>{safeTranslate('promotion_page_block_1_text')}</div>
              <Button
                margin={[32, 0, 0]}
                typeButton="primary"
                text={t('promotion_page_block_1_button')}
                onClick={() => router.push('/my-sexjobs/ads?activeTab=online')}
              />
            </div>
            {deviceType === 'desktop' && (
              <div className={styles['img--block']}>
                <img src="/images/promotion/Gold_Ad.png" alt="Gold_Ad" />
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};
GoldAd.propTypes = {
  deviceType: PropTypes.string,
};
export default memo(GoldAd);
